import { Box, Flex, Text } from '@chakra-ui/react';
import { buyerCurrencyFormatter } from '@diamond/shared/utils';

interface TotalPriceSectionProps {
  savedPrice: number;
  originalPrice: number;
  error?: string;
}

export function TotalPriceSection({
  savedPrice,
  originalPrice,
  error,
}: TotalPriceSectionProps) {
  return (
    <>
      <Box mb={2}>
        <Text fontSize="sm" fontWeight="semibold" color="#00003D">
          Total
        </Text>
        {savedPrice > 0 && (
          <Flex gap={2} mt={0.5} flexWrap="wrap">
            <Text
              fontSize="xs"
              color="gray.500"
              textDecoration="line-through"
            >
              {buyerCurrencyFormatter(originalPrice)}
            </Text>
            <Text fontSize="xs" color="#FF383C">
              Hemat {buyerCurrencyFormatter(savedPrice)}
            </Text>
          </Flex>
        )}
      </Box>
      {error && (
        <Text color="red.500" fontSize="sm" mb={2} textAlign="center">
          {error}
        </Text>
      )}
    </>
  );
}
